import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {register} from 'swiper/element/bundle';

register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    constructor(
      private translate: TranslateService
    ) {
      // Available languages
      translate.addLangs(['en', 'es', 'ca']);

      translate.use('en');
      translate.setDefaultLang('en');

      translate.use('ca');
      translate.setDefaultLang('ca');

      translate.use('es');
      translate.setDefaultLang('es');

      translate.use(localStorage.getItem('lang') || 'es');
      translate.setDefaultLang(localStorage.getItem('lang') || 'es');
    }
}
